//const BackendUrl = 'http://localhost:8000/';
const BackendUrl = 'https://rajatplusmern2.onrender.com/';

export {BackendUrl};